<template>
    <label class="form-label">
        <span
            v-if="text"
            class="form-label__text"
        >
            {{ text }}
        </span>
        <slot></slot>
    </label>
</template>

<script>
export default {
    props: {
        text: String
    }
}
</script>

<style>
.form-label {
    @apply text-sm block w-full;

    &__text {
        @apply block mb-1.5 font-sans-medium;
    }
}
</style>
